module.exports = __webpack_public_path__ + "assets/img/chooseRoleComponentCardIcon1.99f6dc10.svg";